import { InputAdornment, TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface IProps {
    control: Control<any>;
    label: string;
    name: string;
}
export const MoneyField = ({ control, name, label }: IProps) => {
    const handleChange =
        (onChange: (value: any) => void) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const newValue = event.target.value;
            const regex = /^\d+(\.\d{0,2})?$/;
            // Регулярное выражение, разрешающее только цифры и запятуюс

            const isValid = regex.test(newValue);
            if (newValue === "" || isValid) {
                onChange(newValue);
            }
        };

    return (
        <Controller
            name={name}
            control={control}
            rules={{
                pattern: {
                    value: /^\d+(\.\d{0,2})?$/,
                    message: "Допустимы только цифры и точка (до 2 знаков после точки)",
                },
            }}
            render={({ field: { onChange, value, ...field } }) => (
                <TextField
                    {...field}
                    defaultValue={"0"}
                    size={"small"}
                    onChange={handleChange(onChange)}
                    onBlur={() => {
                        field.onBlur();
                    }}
                    value={value ? value : 0}
                    label={label}
                    inputProps={{
                        inputMode: "decimal",
                        pattern: "[0-9.]*",
                    }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">₽</InputAdornment>,
                    }}
                    fullWidth
                />
            )}
        />
    );
};
